import { BaseError } from '@kiplin/web-common/error';

export class NoSelectedClientIdError extends BaseError {
  public constructor() {
    super('cd75b57d-85fa-4db4-874f-f08cb353f091', 'No selected client id');
  }
}
